export enum SituacaoFuncionario {
  ATIVO = 'ATIVO',
  AFASTADO = 'AFASTADO',
  FERIAS = 'FERIAS',
  DESLIGADO = 'DESLIGADO',
  NAO_ENCONTRADA = 'NAO_ENCONTRADA'
}

export const SituacaoFuncionarioLabels: Record<
  keyof typeof SituacaoFuncionario,
  string
> = {
  ATIVO: 'Ativo',
  AFASTADO: 'Afastado',
  FERIAS: 'Férias',
  DESLIGADO: 'Desligado',
  NAO_ENCONTRADA: 'Não Encontrada'
};

export const SituacaoFuncionarioSelectValues = Object.entries(
  SituacaoFuncionarioLabels
).map(([value, label]) => ({ value, label }));
